export default {
  header:{
    text1:'首頁',
    text2:'關於',
    text3:'遊戲',
  },
  banner:{
    text1:'創造更好的遊戲',
    text2:'我們致力於創造更佳的遊戲體驗，將創新與高品質結合，帶來更愉快的遊戲樂趣。',
    text3:'了解更多',
    text4:'歡迎來到S1',
    text5:'我們屢獲殊榮的老虎機遊戲系列擁有獨特的自主開發內容，包含多款遊戲，並支援多種貨幣。',
    text6:'立即試玩',
  },
  about:{
    txt1:'關於我們',
    txt2:'這是我們的故事',
    txt3:'我們是 S1 Gaming',
    txt4:'我們對遊戲的熱情無窮無盡',
    txt5:'在 S1 Gaming，我們以創新為驕傲，並在遊戲產業中突破界限超過十年。我們的目標是提供表現卓越的遊戲，搭配高品質的圖形設計、創新的遊戲機制以及強大的玩家互動性。S1 Gaming 重視多樣化的遊戲組合，提供各種主題與機制的全球化遊戲選擇。',
    text6:'難以置信的功能',
    text7:'遊戲產品特色',
    text8:'高品質遊戲',
    text9:'採用一流的互動藝術進行內部設計。',
    text10:'公平性',
    text11:'公平的遊戲機制與穩定的數值波動。',
    text12:'多平台支援',
    text13:'支援大多數流行的瀏覽器與作業系統。',
    text14:'API 整合',
    text15:'提供詳細的技術文檔，為合作夥伴提供流暢的對接流程。',
  },
  home:{
    text1:'最齊全',
    text2:'遊戲一覽',
    text3:'最新',
    text4:'敬請期待',
    text5:'所有遊戲',
    text6:'',
  },
  message: {
    text1: '遊戲',
    text2: '遊戲產品特色',
    text4: 'Lucky Gaming 擁有在程式技術、美術設計、數值工程等多領域的專業人才，不斷擴展團隊，開發出許多獨具特色的遊戲，並致力於成為最具競爭力的遊戲品牌。',
    text5: '高品質遊戲',
    text6: '採用一流的互動藝術進行內部設計。',
    text7: '公平性',
    text8: '公平的遊戲機制與穩定的數值波動。',
    text9: '多平台支援',
    text10: '支援大多數流行的瀏覽器與作業系統。',
    text11: 'API 整合',
    text12: '提供詳細的技術文檔，為合作夥伴提供流暢的對接流程。',
    text13: '首頁',
    text14: '登入',
    text15: '帳號',
    text16: '密碼',
    text17: '特色遊戲',
    text18: '試玩',
    text19: '無數據',
    text20: '敬請期待',
    text21: 'Lucky Gaming原創',
    text22: '歡迎來到最精彩的線上博奕！',
    text23: '這是一個由 Lucky Gaming 開發團隊專門為您打造的精選系列！',
    text24: '加載中...',
    text25: '',
    text26: '',
  },
  games: {
    text1: "奧林匹斯寶石",
    text2: "金麻將2",
    text3: "霹靂火球 亡靈節",
    text4: "黃金礦工",
    text5: "非洲世界",
    text6: "艷后寶藏",
    text7: "埃及傳說",
    text8: "霹靂火球 侏儸紀",
    text9: "夏威夷天堂",
    text10: "極速之王",
    text11: "霹靂火球 象財神",
    text12: "角鬥士",
  },
  seo: {
    logo: '在 S1 Gaming，我們以創新為驕傲，並在遊戲產業中突破界限超過十年。我們的目標是提供表現卓越的遊戲，搭配高品質的圖形設計、創新的遊戲機制以及強大的玩家互動性。S1 Gaming 重視多樣化的遊戲組合，提供各種主題與機制的全球化遊戲選擇。',
    game1: '奧林匹斯寶石的獨特設計，散發著富麗堂皇的光澤，融合古希臘神話元素。',
    game2: '金龍和麻將牌的組合，代表著中國傳統文化中的運氣與幸運。',
    game3: '亡靈節的霹靂火球，炙熱的火焰與萬聖夜的陰影交織，營造出濃厚的節慶氛圍。',
    game4: '周圍是閃閃發光的金礦石，象徵著金礦開採的艱辛與豐富的收穫。',
    game5: '非洲大陸的壯觀景觀，畫面中包括草原、野生動物和日落，營造出一種平靜且壯麗的自然氛圍。',
    game6: '艷后寶藏的精緻珠寶和古代遺物，代表著古埃及的奢華與神秘。',
    game7: '埃及傳說中的神祇與古代符號，展示了古埃及神話中的力量與神秘世界。',
    game8: '一顆熾熱的火球在侏儸紀的天空中飛過，背景是恐龍群和古代森林，充滿史前的神秘感。',
    game9: '夏威夷天堂般的海灘，碧藍的海水與白沙灘交織，遠處的棕櫚樹搖曳生姿，呈現出熱帶天堂的寧靜景色。',
    game10: '極速之王的賽車在賽道上高速行駛，留下炙熱的輪胎印跡，展現無與倫比的速度與力量。',
    game11: '霹靂火球的耀眼火光中，象形財神的巨大形象立於中央，彰顯出財富與運勢的象徵。',
    game12: '角鬥士在競技場中揮舞劍與盾，周圍是古羅馬競技場的歷史氛圍，充滿力量與決鬥精神。',
  },
  notFound: {
    text1: '抱歉!您所訪問的頁面不存在，請重新加載!',
    text2: '返回首頁'
  },
  meta: {
    title: 'S1 電子遊戲',
    description: 'S1 Gaming 提供最熱門的 SLOT 遊戲與電子娛樂體驗，立即試玩享受多樣化遊戲樂趣！',
    h1: '立即試玩！S1 Gaming電子遊戲體驗平台',
    about: {
      title: '關於S1 Gaming',
      description: '我們的遊戲開發故事與願景',
      h1: '認識 S1 Gaming 團隊，了解我們如何打造創新遊戲體驗'
    },
    games: {
      title: '立即試玩',
      description: '免費體驗精緻拉霸、專業角子老虎機電子類遊戲',
      h1: '免費體驗角子老虎機遊戲，免下載免註冊！S1 Gaming 提供即時試玩，輕鬆上手，隨時享受樂趣！'
    }
  }
}
